import React from "react";
import config from "../../configData.json";
import {
  createStore,
  getStore,
  clearStore,
  setStore,
  deleteStore,
} from "../Stores";

export const initializeCartData = (name: string): any => {
  createStore(name);
};

export const clearCartData = (name: string): any => {
  clearStore(name);
};

export const getCurrentCart = (name: string): any => {
  let currentCart: string | null = getStore(name);

  if (currentCart === null) {
    initializeCartData(name);
    currentCart = getStore(name);
  }
  return currentCart;
};

export const deleteCartItem = (name: string): void => {
  deleteStore(name);
};

export const updateCart = (cart: any, name: string): void => {
  //update the sessionStorage
  setStore(cart, name);
};

export const getNumberOfCartItems = (name: string): number => {
  if (window.sessionStorage.getItem(config.STORAGE_ROOT + name) !== null) {
    return getCurrentCart(name).length;
  }
  return 0;
};
